<script setup lang="ts">
import type { NovaBoxBoardListEventKpopDanceProps } from '@components/NovaBoxBoardListEventKpopDance/NovaBoxBoardListEventKpopDance.type'
import { NovaModalDialog } from '#components'

const { t } = useI18n()
const { show: modalShow, hide: modalHide } = useModal()

const appStore = useAppStore()
const mypageStore = useMyPageStore()
/* const userStore = useUserStore() */
const isMobile = useCheckMobile()
/* const { kycStatus } = storeToRefs(userStore)
const { certifiedKYC } = useKyc() */
const { showSignInDialog } = useMembershipProcess()
const { gtEvent } = useGoogleTag()

/* const { t } = useI18n() */
const props = defineProps<NovaBoxBoardListEventKpopDanceProps>()
const loginCheck = computed(() => {
  return !!mypageStore.profile
})
// 모바일 이면서 앱이 아닐때
const notAppInMob = computed(() => !appStore.isApp && isMobile)
/* const verifiedKyc = ref(kycStatus.value?.kycAt === 'Y') */

const resistFormLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSevNlM4wF4cjzncZ8vcc381tgJQ5GU6AcX0vuPRmSt7D_dzfQ/viewform'
const applyFormLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSdyQJhbKaNdJn-8otfQzcJjiZ6ARhZ3jnnmmFD2jdULhOVuBw/viewform'
const iosAppDownloadKink = 'https://ilikelm.page.link/aplmnova'
const aosAppDownloadKink = 'https://ilikelm.page.link/anlmnova'

const appDownload = (type: string) => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '앱 다운로드 버튼 클릭',
    eventLabel: props.nttSj,
    eventSlot: appStore.appType || '',
    eventI18nAddr: props.nttSj,
    eventComponent: 'Button',
    nttGroupId: props.nttGroupId,
    userSn: mypageStore.profile?.userSn ? mypageStore.profile?.userSn : '',
  })
  if (type === 'IOS') {
    window.location.href = iosAppDownloadKink
  }
  if (type === 'AOS') {
    window.location.href = aosAppDownloadKink
  }
}
const eventButtonAction = (type: string) => {
  // 앱 여부 체크
  if (!appStore.isApp) {
    modalShow({
      component: NovaModalDialog,
      bind: {
        name: modalsName.MODAL_DIALOG,
        btns: [
          {
            label: t('dialog.event.confirm'),
            theme: 'primary-blue-dark',
            size: 32,
            onClick: async () => {
              await modalHide(modalsName.MODAL_DIALOG)
            },
          },
        ],
      },
      slots: {
        title:
          type === 'regist'
            ? t('dialog.event.regist.title')
            : t('dialog.event.apply.title'),
        content:
          type === 'regist'
            ? t('dialog.event.regist.content')
            : t('dialog.event.apply.content'),
      },
    })
    return
  }
  // 로그인 여부 체크
  if (!loginCheck.value) {
    gtEvent('clickEvent', {
      eventCategory: '클릭',
      eventAction:
        '이벤트 상세 > 이벤트 참여 버튼 클릭(비 로그인 상태) > 로그인',
      eventLabel: props.nttSj,
      eventSlot:
        type === 'regist' ? 'Register for competition' : 'Apply for event',
      eventI18nAddr: props.nttSj,
      eventComponent: 'Button',
      nttGroupId: props.nttGroupId,
      userSn: mypageStore.profile?.userSn ? mypageStore.profile?.userSn : '',
    })
    showSignInDialog()
    return
  }
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '이벤트 상세 > 이벤트 참여 버튼 클릭',
    eventLabel: props.nttSj,
    eventSlot:
      type === 'regist' ? 'Register for competition' : 'Apply for event',
    eventI18nAddr: props.nttSj,
    eventComponent: 'Button',
    nttGroupId: props.nttGroupId,
    userSn: mypageStore.profile?.userSn ? mypageStore.profile?.userSn : '',
  })
  // 버튼에 따라 다른 액션 작동
  switch (type) {
    case 'regist':
      window.location.href = resistFormLink
      break
    case 'apply':
      window.location.href = applyFormLink
      break
    default:
  }
}
// kyc 인증 여부 판단
/* const verifyKYC = async () => {
  if (!loginCheck.value) {
    gtEvent('clickEvent', {
      eventCategory: '클릭',
      eventAction: '이벤트 상세 > kyc 인증하기 클릭(비 로그인 상태) > 로그인',
      eventLabel: props.nttSj,
      eventSlot: '',
      eventI18nAddr: props.nttSj,
      eventComponent: 'Button',
      nttGroupId: props.nttGroupId,
      userSn: mypageStore.profile?.userSn ? mypageStore.profile?.userSn : '',
    })
    await showSignInDialog()
    return
  }
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: 'KYC 인증하기 클릭',
    eventLabel: props.nttSj,
    eventSlot: '',
    eventI18nAddr: props.nttSj,
    eventComponent: 'Button',
    nttGroupId: props.nttGroupId,
    userSn: mypageStore.profile?.userSn ? mypageStore.profile?.userSn : '',
  })
  await certifiedKYC('reward')
} */

/* const copyWalletAddress = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '지갑주소 복사하기 클릭',
    eventLabel: props.nttSj,
    eventSlot: '',
    eventI18nAddr: props.nttSj,
    eventComponent: 'Button',
    nttGroupId: props.nttGroupId,
    userSn: mypageStore.profile?.userSn ? mypageStore.profile?.userSn : '',
  })
  if (props.walletAddress) {
    useCopyToClipboard(props.walletAddress)
    useToast(t('copyToClipboard'))
  }
} */

/* const formatAddress = (address: string) => {
  if (address.length <= 10) return address
  return `${address.slice(0, 6)}...${address.slice(-4)}`
} */

/* const formattedWalletAddress = computed(() => {
  return props.walletAddress ? formatAddress(props.walletAddress) : ''
}) */
</script>

<template>
  <div class="content board-detail-contents">
    <div class="event-kpopdance-wrap">
      <div class="img-wrap">
        <img
          src="@/assets/images/events/event-kpop-dance-240716.jpg?url"
          alt="The 1st 2024 KPOP COVER DANCE IN BANGKOK"
        />
        <div class="btn-store">
          <button
            type="button"
            class="btn-google"
            title="Google Play"
            :class="{ 'disabled-cursor': !appStore.isApp }"
            :disabled="!notAppInMob"
            @click.stop="appDownload('AOS')"
          >
            <img
              src="@/assets/images/events/btn-google-play.png?url"
              alt="Google Play"
            />
          </button>
          <button
            type="button"
            class="btn-app"
            title="App Store"
            :class="{ 'disabled-cursor': !appStore.isApp }"
            :disabled="!notAppInMob"
            @click.stop="appDownload('IOS')"
          >
            <img
              src="@/assets/images/events/btn-app-store.png?url"
              alt="Google Play"
            />
          </button>
        </div>
        <!--
        <div class="kyc-wrap">
          <button
            v-if="!verifiedKyc"
            type="button"
            class="event-link apply text-aln-center"
            :class="{ 'disabled-cursor': !appStore.isApp }"
            :disabled="!appStore.isApp"
            @click.stop="verifyKYC()"
          >
            <span class="label">Complete KYC Verification</span>
          </button>
          <button v-else type="button" class="event-link apply">
            <span class="label user-select">{{ formattedWalletAddress }}</span>
            <span class="label btn-copy" @click.stop="copyWalletAddress">
              복사하기
            </span>
          </button>
        </div>-->
      </div>
      <div class="button-wrap">
        <button
          type="button"
          class="event-link register"
          @click.stop="eventButtonAction('regist')"
        >
          <span class="label">Register for competition</span>
        </button>
        <button
          type="button"
          class="event-link apply"
          @click.stop="eventButtonAction('apply')"
        >
          <span class="label">Apply for event</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.event-kpopdance-wrap {
  position: relative;

  .img-wrap {
    position: relative;
    .btn-store {
      display: flex;
      justify-content: space-between;
      position: absolute;
      left: 0;
      bottom: 20.11%;
      gap: 7.2%;
      flex-direction: row;
      width: 100%;
      padding: 0 12.47%;
      @include mobile {
        bottom: 20%;
      }
      img {
        border-radius: 0;
      }
    }
  }

  .kyc-wrap {
    position: absolute;
    left: 0;
    bottom: 25.36%;
    width: 100%;
    padding: 0 17.42%;
    .event-link {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 2%;
      color: #ffffff;
      aspect-ratio: 25 / 4;
      width: 100%;
      padding: 0.52% 9.46%;
      background: url('@/assets/images/events/btn-kyc-bg.png?url') no-repeat
        center center;
      background-size: 100% 100%;
      @include text-style($text-custom-40-bold);
      font-size: 2rem;
      line-height: 1.1em;
      @include tablet {
        padding: 3% 9.46%;
        font-size: 1.5rem;
        line-height: 1.1em;
      }
      @include mobile {
        padding: 2% 9.46%;
        font-size: 0.9rem;
        line-height: 1.1em;
      }
      &.text-aln-center {
        justify-content: center;
        font-size: 1.8rem;
        padding: 0.52% 5px;
        @include tablet {
          font-size: 1.1rem;
          line-height: 1.1em;
        }
        @include mobile {
          font-size: 0.7rem;
          line-height: 1.1em;
        }
      }

      .btn-copy {
        display: inline-block;
        width: 50px;
        height: 50px;
        background: url('@/assets/images/events/tabler_copy.png?url') no-repeat
          center center;
        background-size: 100% auto;
        text-indent: -9999em;
        @include tablet {
          width: 36px;
          height: 36px;
        }
        @include mobile {
          width: 26px;
          height: 26px;
        }
      }
      .user-select {
        user-select: none;
      }
    }
  }

  .button-wrap {
    position: absolute;
    bottom: 4.04%;
    left: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    row-gap: 64px;
    width: 100%;
    padding: 0 8.6%;
    @include tablet {
      row-gap: 32px;
    }
    @include mobile {
      row-gap: 18px;
    }
    .event-link {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 105px;
      width: 100%;
      padding: 12px 8px;
      gap: 8px;
      border-radius: 12px;
      background: linear-gradient(
        90deg,
        rgba(255, 26, 228, 0.6) 0%,
        rgba(181, 0, 232, 0.6) 100%
      );
      box-shadow: 4px 4px 10px 0px rgba(255, 255, 255, 0.3);
      word-break: keep-all;
      @include tablet {
        min-height: 64px;
        padding: 8px 6px;
      }
      @include mobile {
        min-height: 44px;
        padding: 6px 4px;
        border-radius: 8px;
      }

      .label {
        @include text-style($text-custom-40-bold);
        line-height: 1.2em;
        color: #ffffff;
        @include tablet {
          @include text-style($text-custom-30-bold);
          line-height: 1.2em;
        }
        @include mobile {
          @include text-style($text-custom-18-bold);
          line-height: 1.2em;
        }
      }
    }
  }
  .disabled-cursor {
    cursor: default;
  }
}
</style>
